import { SupplierGet, Ulid } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import {
    createEmitter,
    createListController,
    getIdWithCompany,
} from "../utils";
import { Supplier } from "./interfaces";

export const makeSupplier = ({ connection, company }: ApiSliceParams) => {
    const { emit, on, off } = createEmitter<Supplier>();
    const {
        items: suppliers,
        allLoading: loading,
        allLoaded: loaded,
        listen: listenCompany,
    } = createListController<SupplierGet, Supplier, string>({
        name: "supplier",
        connection,
        list: (con, company) => con.supplier.items({ company }),
        getId: (item, company) => getIdWithCompany(item.id, company),
        getKey: (company) => company,
        emit,
    });

    const listen = () => listenCompany(company.value);

    const get = (
        id: string | Readonly<Ulid> | null | undefined,
        company: string,
    ) => {
        if (!id) {
            return null;
        }

        const key = getIdWithCompany(id, company);

        return suppliers.value.find((s) => s.id === key) ?? null;
    };

    return {
        suppliers,
        loading,
        loaded,
        on,
        off,
        listen,
        listenCompany,
        get,
    };
};
